'use client';

import type { Root } from 'react-dom/client';
import { createRoot } from 'react-dom/client';

import CommonModal from './index';
import type { ModalConfig } from './useCommonModal';

class ModalManager {
  private container: HTMLDivElement | null = null;
  private root: Root | null = null;

  private getContainer() {
    if (!this.container) {
      this.container = document.createElement('div');
      document.body.appendChild(this.container);
      this.root = createRoot(this.container);
    }

    return { container: this.container, root: this.root! };
  }

  private destroy() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }

    if (this.container) {
      document.body.removeChild(this.container);
      this.container = null;
    }
  }

  open(config: ModalConfig) {
    const { root } = this.getContainer();

    const handleClose = () => {
      this.close();
      config.onClose?.();
    };

    root.render(<CommonModal {...config} onClose={handleClose} open={true} />);

    return {
      close: () => this.close(),
      update: (newConfig: Partial<ModalConfig>) => {
        root.render(<CommonModal {...config} {...newConfig} onClose={handleClose} open={true} />);
      }
    };
  }

  close() {
    this.destroy();
  }
}

// 导出单例
export const modal = new ModalManager();
